import React, { useState } from "react";
import { SVG } from "../../../component-configuration/svgs";

const BulletPoints = () => {
  const [showEE, setShowEE] = useState(false);
  const [showEP, setShowEP] = useState(false);

  const ecosystemPoints = [
    "Grow your audience & brand",
    "Connect to investors",
    "Discover new deal flow  & partners",
    "Be promoted on Radivision, Pitch Planet, social media & more",
    "Update followers with your progress, success & calls-to-action",
    "Grow traffic to your campaigns & sites",
  ];

  const viewersPoints = [
    "Be Inspired!",
    "Discover & connect with Radical Visionaries changing our world",
    "Follow your favorite founders, startups, & organizations for their latest news",
    "Learn from The Experts, access resources & discover new products & services",
    "Participate in startup innovation & wealth creation opportunities",
  ];
  return (
    <>
      {/* <h3>Member Benefits</h3> */}
      <div className={`bullet-points`}>
        <div className={`points ${showEE ? "expanded" : ""}`}>
          <h5 className="title" onClick={() => setShowEE(!showEE)}>
            <span className="expand-icon">{showEE ? SVG.dash : SVG.plus}</span>
            <span>Benefits for Founders & Investors</span>
          </h5>
          {showEE && (
            <ul>
              {viewersPoints.map((VP) => {
                return (
                  <>
                    <li>
                      <p>{VP}</p>
                    </li>
                  </>
                );
              })}
            </ul>
          )}
        </div>
        <div className={`points ${showEP ? "expanded" : ""}`}>
          <h5 className="title" onClick={() => setShowEP(!showEP)}>
            <span className="expand-icon">{showEP ? SVG.dash : SVG.plus}</span>
            <span>Benefits for Members & Partners</span>
          </h5>
          {showEP && (
            <ul>
              {ecosystemPoints.map((EP) => {
                return (
                  <>
                    <li>
                      <p>{EP}</p>
                    </li>
                  </>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </>
  );
};

export default BulletPoints;
